module.exports = __webpack_public_path__ + "static/media/approved.8b563588.png";